import { render } from "./2981917.vue?vue&type=template&id=19f04d50"
const script = {}

import exportComponent from "/data/jenkins/workspace/recopick-docs-static-prd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__